import React from 'react';
import { Box, Typography, Container, Paper, Button, Divider, styled } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import FavoriteIcon from '@mui/icons-material/Favorite';
import EmailIcon from '@mui/icons-material/Email';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3, 5),
  borderRadius: '20px',
  textAlign: 'center',
  background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
  border: '2px solid #e8f5e8',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3)
  }
}));

const StyledCheckIcon = styled(CheckCircleOutlineIcon)({
  fontSize: '100px',
  color: '#4caf50',
  marginBottom: '16px',
  filter: 'drop-shadow(0 4px 8px rgba(76, 175, 80, 0.3))'
});

const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5, 4),
  fontSize: '1.1rem',
  borderRadius: '10px',
  boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
    transform: 'translateY(-1px)'
  }
}));


const DonationSuccess: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <StyledPaper elevation={6}>
        <Box sx={{ mb: 3 }}>
          <StyledCheckIcon />
        </Box>

        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{
            color: '#2e7d32',
            fontWeight: 'bold',
            mb: 2,
            fontSize: { xs: '1.8rem', md: '2.5rem' }
          }}
        >
          Bağışınız Başarıyla Alındı!
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mb: 3,
            color: '#1b5e20',
            fontWeight: 500,
            fontSize: { xs: '1.1rem', md: '1.3rem' }
          }}
        >
          <FavoriteIcon sx={{ mr: 1, color: '#e91e63', verticalAlign: 'middle' }} />
          Katkınız için çok teşekkür ederiz!
        </Typography>

        <Divider sx={{ my: 3, borderColor: '#e8f5e8' }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="body1" sx={{ mb: 2, color: '#424242', fontSize: '1.1rem' }}>
            Bağışınız başarıyla tamamlanmıştır ve ODTÜ Geliştirme Vakfı'na ulaşmıştır.
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <StyledButton
            variant="contained"
            color="primary"
            size="large"
            href="/"
          >
            Yeni Bağış Yap
          </StyledButton>
          <Button
            variant="outlined"
            size="large"
            href="https://odtugv.org.tr"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              py: 1.5,
              px: 4,
              fontSize: '1.1rem',
              borderRadius: '10px',
              borderColor: '#1976d2',
              color: '#1976d2',
              '&:hover': {
                borderColor: '#1976d2',
                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                transform: 'translateY(-1px)'
              },
              transition: 'all 0.3s ease'
            }}
          >
            VAKIF WEB SİTESİ
          </Button>
        </Box>
      </StyledPaper>
    </Container>
  );
};

export default DonationSuccess;
